// Page Path : src\pages\design\document\configuration\secondary-screen.tsx

import { Box, CircularProgress } from '@mui/material';

import { useEffect, useState } from 'react';
import { useImageViewer } from 'hooks/useImageViewer';
import ImageViewerRightPane from './right-pane';
import { FileHeaderData, IMAGE_VIEWER_DUAL_SCREEN_ACTIONS, UpdateQcTableCellPayload } from 'types/image-viewer';

const SecondaryScreen = () => {
  const [initialised, setInitialised] = useState(false);
  const IsFromDpc = localStorage.getItem('isFromDPC') === 'true' ? true : false;
  const {
    currentPageDetails,
    setCurrentPageNumber,
    setIsRighpanelImageLoading,
    currentPageNumber,
    isLoadingImageBytes,
    searchTextInFile,
    fileLevelDetails,
    canvasFunctionRef,
    onSelectTabcelCell,
    setSelectedField
  } = useImageViewer();

  useEffect(() => {
    window.addEventListener('message', (event) => {
      // Validate the origin of the message
      if (event.origin !== window.location.origin) {
        return;
      }
      const { type, payload } = event.data;
      switch (type) {
        case IMAGE_VIEWER_DUAL_SCREEN_ACTIONS.LATEST_STATE:
        case IMAGE_VIEWER_DUAL_SCREEN_ACTIONS.CLIENT_STATE_UPDATED:
          const { currentPageNumber } = payload;
          setCurrentPageNumber(currentPageNumber);
          setInitialised(true);
          break;

        case IMAGE_VIEWER_DUAL_SCREEN_ACTIONS.ON_SELECTE_TABLE_CELL: {
          onSelectTabcelCell(payload as UpdateQcTableCellPayload);
          break;
        }

        case IMAGE_VIEWER_DUAL_SCREEN_ACTIONS.ON_SELECTE_FIELD: {
          setSelectedField(payload as FileHeaderData);
          break;
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setCurrentPageNumber]);

  // get the latest client state from primary window for first time
  useEffect(() => {
    if (window.opener) {
      window.opener.postMessage(
        {
          type: IMAGE_VIEWER_DUAL_SCREEN_ACTIONS.GET_LATEST_STATE
        },
        window.location.origin
      );
    }
  }, []);

  const updateFieldROI = (newROI: string) => {
    if (window.opener) {
      window.opener.postMessage(
        {
          type: IMAGE_VIEWER_DUAL_SCREEN_ACTIONS.UPDATE_FIELD_ROI,
          payload: newROI
        },
        window.location.origin
      );
    }
  };

  return (
    <Box className="image-viewer-secondary-screen">
      {initialised ? (
        <Box className="configuration-right-pane">
          <ImageViewerRightPane
            currentPageDetails={currentPageDetails}
            currentPageNumber={currentPageNumber}
            setCurrentPageNumber={setCurrentPageNumber}
            isSecondaryScreen
            currentFileId={0}
            searchTextInFile={searchTextInFile}
            updateFieldROI={updateFieldROI}
            handleFileNavigation={() => () => undefined}
            isLoadingImageBytes={isLoadingImageBytes}
            fileLevelDetails={fileLevelDetails}
            canvasFunctionRef={canvasFunctionRef}
            shouldRestrictModification={IsFromDpc}
            setIsRighpanelImageLoading={setIsRighpanelImageLoading}
          />
        </Box>
      ) : (
        <Box className="configuration-loader-wrapper">
          <CircularProgress />
        </Box>
      )}
    </Box>
  );
};

export default SecondaryScreen;
